import { MenuItem } from '@mui/material';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { ControlledSelect, FormGrid, Section } from '../../../shared';
import { FamilySituation, LivingSituation } from '../../enums';

export const SupportCaseDetailInputs: FC = () => {
    const { t } = useTranslation();

    return (
        <Section title={t('details')}>
            <FormGrid size={{ xs: 12, sm: 6, lg: 3, xl: 2 }} containerProps={{ width: 'inherit' }}>
                <ControlledSelect name={`livingSituation`} label={t('livingSituation')}>
                    <MenuItem value={''}>{t('unknown')}</MenuItem>
                    {Object.values(LivingSituation).map((situation) => (
                        <MenuItem value={situation} key={situation}>
                            {t(situation)}
                        </MenuItem>
                    ))}
                </ControlledSelect>

                <ControlledSelect name={`familySituation`} label={t('familySituation')}>
                    <MenuItem value={''}>{t('unknown')}</MenuItem>
                    {Object.values(FamilySituation).map((situation) => (
                        <MenuItem value={situation} key={situation}>
                            {t(situation)}
                        </MenuItem>
                    ))}
                </ControlledSelect>
            </FormGrid>
        </Section>
    );
};
